import { useState } from "react"
import { VoiceRueckkopplungBlock } from "@/components/portal/VoiceRueckkopplungBlock"

/**
 * Reiter „Telefonbot" unter „Verbessern" (Paul, 17.09.2026): Verbesserungen für
 * den Bot erscheinen hier — und werden erst nach Bestätigung zum Ticket.
 */
export default function TelefonbotRueckkopplungPage() {
  const [tage, setTage] = useState(30)
  return (
    <div className="px-10 py-6 max-w-[1100px]">
      <p className="text-[13px] text-muted-foreground mb-4 max-w-[72ch]">
        Nach jedem Anruf des Telefonbots schaut das System nach, ob das Büro nacharbeiten musste — Rückruf, Warnung,
        gescheiterte Weiterleitung — und warum. Aus wiederkehrenden, vermeidbaren Gründen entstehen hier Vorschläge.
        Ein Ticket wird daraus erst, wenn Sie es bestätigen.
      </p>
      <label className="inline-flex items-center gap-1.5 text-[13px] mb-4">
        Zeitraum
        <select className="border rounded px-2 py-1 bg-transparent" value={tage} onChange={(e) => setTage(Number(e.target.value))}>
          {[14, 30, 90].map((t) => <option key={t} value={t}>{t} Tage</option>)}
        </select>
      </label>
      <VoiceRueckkopplungBlock tage={tage} tenant="" />
    </div>
  )
}
